export default __webpack_public_path__ + "static/media/AIFG_Badge.1f2f8c40.svg";